import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'shared-zap',
  `
    LOAD_SHARED_ZAP
    LOAD_SHARED_ZAP_DONE
    LOAD_SHARED_ZAP_FAIL,

    ADD_SHARED_ZAP_FLOW

  `
);
